"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  strokeClassName: 'ql-stroke',
  fillClassName: 'ql-fill',
  evenClassName: 'ql-even',
  colorLabelClassName: 'ql-color-label',
  transparentClassName: 'ql-transparent',
  strokeMitterClassName: 'ql-stroke-mitter',
  thinClassName: 'ql-thin',
  colorStyle: undefined,
  width: '18px',
  height: '18px'
};
exports.default = _default;